const TAB_ACTION = 'tab_loaded' as const;

export const TAB_LOADED_EVENTS = {
  WHATS_NEW: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'whats_new',
  },
  UPGRADES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'upgrades',
  },
  PATIENTS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'patients',
  },
  PATIENTS_HELP: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'patients_help',
  },
  MANAGED_REPEATS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'managed_repeats',
  },
  WORKFLOW_DASHBOARD: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'workflow_dashboard',
  },
  SERVICES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'services',
  },
  SERVICE_DASHBOARD: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'service_dashboard',
  },
  CALENDAR: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'calendar',
  },
  BROADCASTING: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'broadcasting',
  },
  RESOURCES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'resources',
  },
  SMS_CAMPAIGNS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'sms_campaigns',
  },
  SUPER_LINKS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'super_links',
  },
  MARKETING_MATERIAL: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'marketing_material',
  },
  TRAINING_AND_GUIDES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'training_and_guides',
  },
  IN_APP_BANNERS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'banners',
  },
} as const;
